(function( app, marketinOffer, $, undefined ) {
  'use strict';

  var formElements = {
    'eligibility_option': '#PLACEHOLDER_offer_slot_eligibility',
    'offers_option': '#PLACEHOLDER_offer_slot_offer_id'
  }
  
  function _currentFormElement(rawPlaceholder) {
    return rawPlaceholder.replace('PLACEHOLDER', app.data.offerSlotType)
  }

  var initialLoad = true

  // Public Method
  marketinOffer.initForm = function() {
    formElements['eligibility_option'] = _currentFormElement(formElements['eligibility_option'])
    formElements['offers_option'] = _currentFormElement(formElements['offers_option'])

    // Offers Dropdwon
    $(formElements['offers_option']).select2({
      placeholder: 'Select an Offer ...',
      allowClear: false
    })
        
    $(formElements['eligibility_option']).select2({
      allowClear: false
    }).on('change', function() {
      _changeOffersList()
    });

    // Initialization
    _changeOffersList()
  }

  function _changeOffersList() {
    var offerOptionsElement = $(formElements['offers_option'])
    var selectedEligbility = $(formElements['eligibility_option']).val()

    // Get Selected Offer 
    var selectedOffer  = offerOptionsElement.val()
    if(initialLoad){
      initialLoad = false
      selectedOffer = String(app.data.selectedOffer)
    }

    // Get List of Filtered offers by Eligibility
    var offers = _offersList(selectedEligbility)

    offerOptionsElement.empty()
    if(offers.length == 0) {
      offerOptionsElement.val(' ').trigger('change');
      offerOptionsElement.val(' ').trigger('select2:select');
      return
    }

    offers.sort((a, b) => a.internal_name > b.internal_name ? 1 : -1).forEach( function(offer){      
      var label = offer.internal_name
      var value = offer.id
      var newOption = new Option(label, value, false, false);
      offerOptionsElement.append(newOption)
    })

    if(selectedOffer != null && selectedOffer != undefined){
      offerOptionsElement.val(selectedOffer).trigger('change');
    }

    offerOptionsElement.trigger('select2:select');
  }

  function _offersList(eligibility) {
    return app.data.offers.filter(x => String(x.eligibility) === String(eligibility))
  }

}( window.app ||= {}, 
  window.app.offerSlot ||= {}, 
  jQuery 
));

(function ($) {
  $(function() {
    // INIT the Onboarding Offer Slot form
    if ($('#edit_onboarding_offer_slot').length 
          || $('#new_onboarding_offer_slot').length
          || $('#edit_user_offer_slot').length
          || $('#new_user_offer_slot').length
          || $('#edit_homepage_offer_slot').length
          || $('#new_homepage_offer_slot').length) {
      app.offerSlot.initForm();
    }
  })
})(jQuery);
